import React, { useState } from 'react'
import { Box, Button } from 'rebass'
import LazyLoad from 'react-lazyload'
import Flipcard from '@kennethormandy/react-flipcard'
import '@kennethormandy/react-flipcard/dist/Flipcard.css'
import AspectRatio from 'react-aspect-ratio'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import Title from '../components/Title'

const query = graphql`
  query {
    cover: file(relativePath: { eq: "flipit.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 700) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Wrap = styled(Box)`
  position: relative;

  .Flipcard-flipper {
    height: 100%;
  }

  .Flipcard-back,
  .Flipcard-front {
    height: 100%;
    width: 100%;
  }
`

const ButtonWrap = styled(Box)`
  display: none;

  @media (min-width: ${props => props.theme.breakpoints[0]}) {
    display: block;
    position: absolute;
    right: 2%;
    top: 50%;
  }

  @media (min-width: ${props => props.theme.breakpoints[1]}) {
    right: 11%;
  }
`

const FlipItButton = styled(Button)`
  background: transparent;
  appearance: none;
  transform: rotate(30deg) scale(-1, 1);
  font-size: ${props => props.theme.fontSizes[7]}px;
  text-transform: uppercase;
  color: ${props => props.theme.colors.yellow};
  letter-spacing: 0;

  &:focus {
    outline: 0;
  }

  &:hover {
    opacity: 0.4;
  }
`

const Spotify = () => {
  const [flipped, setFlipped] = useState(true)
  const handleFlip = () => setFlipped(!flipped)
  return (
    <StaticQuery
      query={query}
      render={data => (
        <Wrap bg="black">
          <Title color="yellow" textAlign="center">
            Listen
          </Title>
          <Box mt={36}>
            <AspectRatio
              ratio={1 / 1}
              style={{ maxWidth: 550, margin: '0 auto' }}
            >
              <Flipcard flipped={flipped}>
                <Box key="front">
                  <Img fluid={data.cover.childImageSharp.fluid} />
                </Box>
                <Box key="back" css={{ height: '100%' }}>
                  <LazyLoad height={'100%'} once key="front">
                    <iframe
                      title="Playlist"
                      width="100%"
                      height="100%"
                      src="https://open.spotify.com/embed/user/teganandsara/playlist/0VQFGeb3HoQYJan5Jn28tP"
                      frameBorder="0"
                      allowtransparency="true"
                      allow="encrypted-media"
                    />
                  </LazyLoad>
                </Box>
              </Flipcard>
            </AspectRatio>
            <ButtonWrap>
              <FlipItButton onClick={handleFlip}>Flip It!</FlipItButton>
            </ButtonWrap>
          </Box>
        </Wrap>
      )}
    />
  )
}

export default Spotify
